import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/Calculator/CementscreedCalculator/cementscreedCalculator.container"
    ).then((module) => ({ default: module.CementscreedCalculator }))
);
